<template>
  <div class="container">
    <div class="title">{{ $t("notification.general") }}</div>
    <div class="linkbox">
      <router-link class="linkitem" to="/w/home/user/general">
        <i class="iconfont icon-wenjian"></i>
        {{ $t("notification.general") }}
      </router-link>
      <router-link class="linkitem" to="/w/home/user/notification">
        <i class="iconfont icon-wenjian"></i>
        {{ $t("notification.notice") }}
      </router-link>
    </div>
    <div class="flexbox-c membercontent">
      <!-- 基本资料 -->
      <div class="formbody">
        <div class="boxhead">
          <div class="formitemtitle">
            <i class="iconfont icon-wenjian"></i>
            {{ $t("general.title1") }}
          </div>
        </div>
        <div class="boxbody">
          <div class="boxitem">
            <div class="left">
              {{ $t("general.item1") }}
            </div>
            <div class="center" style="justify-content: flex-start">
              <el-checkbox v-model="form.form1"></el-checkbox>
            </div>
            <div class="right">
              {{ $t("general.tips1") }}
            </div>
          </div>
        </div>
      </div>
      <!-- 保存 -->
      <div class="flexbox usereditcontainer">
        <div class="flexbox commonbtn" @click="save">
          <div class="textbox">{{ $t("user.edit.save") }}</div>
          |
          <div class="iconbox">
            <i class="iconfont icon-tubiaozhizuomoban"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        form1: true
      }
    }
  },
  methods: {
    save () {
      this.$message.success(this.$t('tips.savesuccess'));
    }
  }
}
</script>

<style lang="scss" scoped>
$boderColor: rgba(
  $color: #fff,
  $alpha: 0.2,
);
$border: 1px solid $boderColor;
.container {
  width: 1000px;
  padding: 100px 30px;
  .title {
    font-size: 20px;
    color: $themeColor;
    margin-bottom: 28px;
    font-weight: bold;
  }
  .linkbox {
    .linkitem {
      padding: 10px 10px;
      background-color: #fff;
      color: $themeColor;
      background-color: transparent;
    }
    .router-link-active {
      background-color: rgb(180, 83, 77);
    }
  }
  .membercontent {
    padding: 30px 10px;
    padding-right: 0;
    background-color: rgba(255, 255, 255, 0.2);
    margin-top: 30px;
    border-radius: 8px;
    min-height: 400px;
  }
  .formtitle {
    width: 100%;
    color: $themeColor;
    font-weight: bold;
    margin-top: 50px;
    margin-bottom: 30px;
    font-size: 20px;
  }
  .formbody {
    width: 800px;
  }
  .formcontent {
    width: 100%;
    word-wrap: break-word;
    font-size: 14px;
    color: #fff;
    text-align: center;
    padding: 14px;
  }
  .boxhead {
    display: flex;
    background: rgba(255, 255, 255, 0.2)
      url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAgCAYAAADaDrJgAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACpJREFUeNpi/P//WRoDGmAB4ifYBF9gE/w3Kkiu4P/Bp/0/DbRTIAgQYAC2PiJjuOjlPgAAAABJRU5ErkJggg==)
      repeat-x left top;
    border: none;
    border-radius: 6px 6px 0px 0px;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    padding-left: 10px;
    border: 1px solid rgba(255, 255, 255, 0.5);
  }
  .boxbody {
    background: rgba(255, 255, 255, 0.05)
      url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAgCAYAAADaDrJgAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACpJREFUeNpi/P//WRoDGmAB4ifYBF9gE/w3Kkiu4P/Bp/0/DbRTIAgQYAC2PiJjuOjlPgAAAABJRU5ErkJggg==)
      repeat-x left top;
    margin-bottom: 10px;
    .boxitem {
      display: flex;
      width: 100%;
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      border-left: 1px solid rgba(255, 255, 255, 0.5);
      border-right: 1px solid rgba(255, 255, 255, 0.5);
      .left {
        width: 30%;
        display: flex;
        padding: 10px;
        justify-content: flex-end;
        align-items: center;
        align-content: center;
        color: #fff;
        font-size: 14px;
        .terms {
          color: $linkColor;
        }
        .terms:hover {
          text-decoration: underline;
        }
      }
      .center {
        width: 30%;
        display: flex;
        padding: 5px;
        justify-content: center;
        align-items: center;
        align-content: center;
        color: #fff;
        font-size: 14px;
        border-left: 1px solid rgba(255, 255, 255, 0.5);
        border-right: 1px solid rgba(255, 255, 255, 0.5);
        .avatar {
          width: 100px;
          height: 100px;
          cursor: pointer;
        }
      }
      .right {
        width: 40%;
        display: flex;
        padding: 10px;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        color: #fff;
        font-size: 14px;
      }
    }
  }
}
.usereditcontainer {
  width: 800px;
  margin-bottom: 30px;
  justify-content: flex-end;
}
.commonbtn {
  width: auto;
  height: 32px;
  justify-content: space-between;
  color: $themeColor;
  background-color: #e8cbed;
  padding: 0 8px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  .textbox {
    padding: 0 5px;
  }
  .iconbox {
    padding: 0 5px;
    font-size: 20px;
  }
}
.fullradiusbox {
  border-radius: 6px;
}
.halfradiusbox {
  border-radius: 6px 6px 0px 0px;
}
.fullradiusbox,
.halfradiusbox {
  background: rgba(255, 255, 255, 0.2)
    url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAgCAYAAADaDrJgAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACpJREFUeNpi/P//WRoDGmAB4ifYBF9gE/w3Kkiu4P/Bp/0/DbRTIAgQYAC2PiJjuOjlPgAAAABJRU5ErkJggg==)
    repeat-x left top;
  border: none;
  border-bottom: none;
  .title {
    justify-content: flex-start;
    padding: 8px 10px;
    font-size: 16px;
    i {
      margin-right: 10px;
      color: $themeColor;
      font-size: 16px;
    }
  }
}

.changepwdbox {
  .boxitem {
    margin-top: 30px;
  }
}
.formitemtitle {
  color: $themeColor;
  width: 100%;
  padding: 10px;
}
</style>